module.exports = __webpack_public_path__ + "img/katarina_outside_14.fda0b250.jpg";